import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FT163 {
  ft163_01: string;
  ft163_02: number;
  ft163_03: number;
  ft163_11: string;   // 追蹤事項內容
  ft163_12: string;   // 到期日
  ft163_13: string;   // 處理情況
  ft163_15: string;   // 負責人員代碼
  ft163_15a: string;  // 負責人員姓名
  ft163_16: string;   // 部門代碼
  ft163_16a: string;  // 部門名稱
}

export interface FT162 {
  ft162_01: string;
  ft162_02: number;
  ft162_11: string;         // 討論內容
  ft162_12: string;         // 決議事項
  ft162_13: string;         // 負責人員代碼
  tracking_items?: FT163[];
}

export interface FT161 {
  ft161_01: string;
  ft161_02: number;
  ft161_11: string;   // 員工代碼
  ft161_11a: string;  // 中文姓名
  ft161_11b: string;  // 英文名
  ft161_12: string;   // 部門代碼
  ft161_12a: string;  // 部門名稱
}

export interface FT164 {
  ft164_01: string;
  ft164_02: number;
  ft164_10: string;  // 客戶人員姓名
  ft164_11: string;  // 職稱
  ft164_13: string;  // 客戶代碼
  ft164_14: string;  // 客戶名稱
}

export interface FT160 {
  ft160_01: string;          // 會議代號 (PK)
  ft160_11: string;          // 會議主題
  ft160_12: string;          // 說明
  ft160_13: string;          // 會議日期
  ft160_14: string;          // 開始時間 (HH:MM:SS)
  ft160_15: string;          // 結束時間 (HH:MM:SS)
  ft160_16: string;          // 會議地點
  ft160_18: number;          // 我司參加人數 (auto)
  ft160_19: number;          // 議題數 (auto)
  ft160_22: string;          // 記錄人代碼
  ft160_25: number;          // 客戶參加人數 (auto)
  our_attendees?: FT161[];
  topics?: FT162[];
  customer_attendees?: FT164[];
}

// ---- Input types for FT162 topics (include tracking_items as input) ----

export interface FT163Input {
  ft163_02?: number;
  ft163_03?: number;
  ft163_11: string;
  ft163_12?: string;
  ft163_13: string;
  ft163_15: string;
  ft163_15a: string;
  ft163_16: string;
  ft163_16a: string;
}

export interface FT162Input {
  ft162_02?: number;
  ft162_11: string;
  ft162_12: string;
  ft162_13: string;
  tracking_items: FT163Input[];
}

export interface CreateT206Request {
  ft160_11: string;  // 會議主題
  ft160_12: string;  // 說明
  ft160_13: string;  // 會議日期
  ft160_14: string;  // 開始時間
  ft160_15: string;  // 結束時間
  ft160_16: string;  // 會議地點
  ft160_22: string;  // 記錄人代碼
  our_attendees: Omit<FT161, 'ft161_01' | 'ft161_02'>[];
  topics: FT162Input[];
  customer_attendees: Omit<FT164, 'ft164_01' | 'ft164_02'>[];
}

export interface UpdateT206Request extends CreateT206Request {}

export interface ListT206Response {
  data: FT160[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

const BASE = '/api/t206';

export const t206Api = {
  async list(page = 1, size = 200, keyword?: string): Promise<ListT206Response> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get(BASE, { params });
    return res.data;
  },

  async getByID(id: string): Promise<FT160> {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: CreateT206Request): Promise<FT160> {
    const res = await apiClient.post(BASE, data);
    return res.data;
  },

  async update(id: string, data: UpdateT206Request): Promise<FT160> {
    const res = await apiClient.put(`${BASE}/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`${BASE}/${encodeURIComponent(id)}`);
  },
};
